"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How long do driveway treatments last?\n",
  answer: "We're based in Dulwich and work across South East and South West London, including Bromley, Wimbledon, Beckenham, Lewisham, Catford, Wandsworth, Croydon, and many surrounding neighbourhoods. If you're unsure whether we cover your area, just give us a call and we'll be happy to help."
}, {
  question: "Can you repair my existing driveway?\n",
  answer: "We offer a comprehensive range of landscaping services including driveways, patios, decking, turfing and artificial grass, fencing, brickwork, water features, garden lighting, garden rooms, and pergolas. Whether you need a single feature or a full garden transformation, we've got you covered."
}, {
  question: "What's the best driveway material?\n",
  answer: "Simply get in touch via our contact form, email, or phone. We'll arrange a free, no-obligation consultation where we visit your space, discuss your ideas, and provide a clear, detailed quote with no hidden costs."
}, {
  question: "How much does a new driveway cost?\n",
  answer: "Every project is different, so costs vary depending on the size, materials, and complexity of the work. We provide transparent, itemised quotes so you know exactly what you're paying for before any work begins. Contact us for a free quote tailored to your specific requirements."
}];
export default function FaqAccordion() {
  return <section id="faqaccordion" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="font-sans font-light text-muted-foreground text-lg md:text-xl">
            Everything you need to know about our landscaping services and process.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
              <AccordionTrigger className="font-default text-lg text-foreground hover:text-primary hover:no-underline transition-colors text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}